// extracted by mini-css-extract-plugin
export default {"opcionesBar":"styles_opcionesBar__YLtZS","alignRight":"styles_alignRight__2vixJ"};